/**
 * A conta das parcelas do cartão na tela (26/10/2026): a mesma da API
 * (`api/src/modules/taxa/parcelamento.ts` e `calcularParcelamentoProduto`), para a
 * página mostrar o valor que a cobrança vai ter. Serve à página de vendas, ao link de
 * pagamento e ao acesso com preço, que deixam quem paga escolher em quantas vezes.
 */

/** O total em N vezes, com o acréscimo por parcela extra em fração (0,02 = 2%). */
export function totalParcelado(valor: number, parcelas: number, acrescimoPorParcelaExtra: number): number {
  return Math.round(valor * (1 + acrescimoPorParcelaExtra * (parcelas - 1)) * 100) / 100
}

/** O valor de cada parcela do cartão em N vezes: o mesmo acréscimo por parcela extra que a API cobra. */
export function valorDaParcela(valor: number, parcelas: number, acrescimoPorParcelaExtra: number): number {
  const total = valor * (1 + acrescimoPorParcelaExtra * (parcelas - 1))
  return Math.round((total / parcelas) * 100) / 100
}

/** Quantas vezes cabem num valor: o limite, cortado pelo piso de R$ 5 por parcela da API. */
export function parcelasQueCabem(valor: number, limite: number | undefined): number {
  const teto = Math.max(1, Math.min(12, Math.floor(limite ?? 1)))
  return Math.max(1, Math.min(teto, Math.floor(valor / 5)))
}

/**
 * O acréscimo por parcela extra que quem paga paga, em fração: o percentual da API
 * (`parcelamento_acrescimo_percentual`, 2 sem ele) quando o acréscimo é dele, e zero
 * quando o personal paga (o "sem juros" para quem paga).
 */
export function acrescimoDeQuemPaga(taxaNoComprador: boolean | undefined, percentual: number | undefined): number {
  return taxaNoComprador === false ? 0 : (percentual ?? 2) / 100
}
